import type { MigrationInterface, QueryRunner } from 'typeorm'

export class AddPersistenceTable1748736000000 implements MigrationInterface {
  public async up(queryRunner: QueryRunner): Promise<void> {
    console.log('running migration UP (AddPersistenceTable1748736000000)')
    await queryRunner.query(`
            CREATE TABLE IF NOT EXISTS "persistence" (
                "key" varchar PRIMARY KEY NOT NULL,
                "value" text NOT NULL
            );
        `)
  }

  public async down(queryRunner: QueryRunner): Promise<void> {
    console.log('running migration DOWN (AddPersistenceTable1748736000000)')
    await queryRunner.query(`
            DROP TABLE "persistence";
        `)
  }
}
